import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router/index';
import axios from 'axios'

//axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';


for (let key in localStorage) {
    //localStorage.removeItem(key);
    //console.log(key, localStorage.getItem(key));
}

// Salvo il menu di default in storage
if (!localStorage.getItem('_cm')) {
    localStorage.setItem('_cm', [0, 3]);
}

Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        VERSION: '1.6.4', // impostare la nuova versione nel file mixins/update.
        ROOT: 'https://italiasoftair.it',
        ROOT_API: 'https://italiasoftair.it/api/v1',
        LST: 'AuthToken',
        _token: false,
        MAP_KEY: 'zku8YUipmNkUdja1guqV',
        loading: false,
        mainmenu: [
            {
                to: '/clubs',
                title: 'Clubs',
                subtitle: 'Clubs',
                icon: 'mdi-account-group-outline',
                flex: 4,
                bgColor: 'purple darken-4',
                dark: true,
                badge: false,
                disabled: false,
            },
            // {
            //     to: '/club-map',
            //     title: 'Mappa Club',
            //     icon: 'mdi-map-legend',
            //     flex: 6,
            //     bgColor: 'red darken-4',
            //     dark: true,
            //     badge: false,
            //     disabled: false,
            // },
            {
                to: '/friendly',
                title: 'Votazioni',
                icon: 'mdi-ballot-outline',
                flex: 4,
                bgColor: 'red darken-4',
                dark: true,
                badge: false,
                disabled: false,
            },
            {
                to: '/events',
                title: 'Eventi',
                icon: 'mdi-flag-variant-outline',
                flex: 4,
                bgColor: 'green darken-4',
                dark: true,
                badge: false,
                disabled: false,
            },
        ],
        customMenu: [],
        flashMsg: '',
        canGeolocate: false,
        unreadNotify: false,
    },
    getters: {
        isLoading: state => {
            return state.loading;
        },
        isLoggedIn: state => {
            return !!state._token;
        },
        isAdmin: () => {
            return localStorage.getItem('_ia') === 'true' || localStorage.getItem('_ia') === true;
        },
        getMemberID: () => {
            return parseInt(localStorage.getItem('_mID'));
        },
        getClubID: () => {
            return parseInt(localStorage.getItem('_cID'));
        },
        getMainClubID: () => {
            return localStorage.getItem('_mc')
        },
        getToken: state => {
            return state._token;
        },
        getAppMenu: state => {
            return state.mainmenu;
        },
        getGeolocate: state => {
            return state.canGeolocate;
        },
        getBottomMenu: state => {
            let bm = [];
            state.mainmenu.forEach((item, index) => {
                if (localStorage.getItem('_cm').includes(index)) {
                    bm.push(item);
                }
            });
            return bm;
        },
    },
    mutations: {
        setToken: (state, _token) => {
            state._token = _token;
        },
        setFlash: (state, flashMsg) => {
            state.flashMsg = flashMsg;
        },
        setLoading: (state, loading) => {
            state.loading = loading;
        },
        setCustomMenu: (state, customMenu) => {
            state.customMenu = customMenu;
        },
        setGeolocate: (state, canGeolocate) => {
            state.canGeolocate = canGeolocate;
        },
        setUnreadNotify: (state, value) => {
            state.unreadNotify = value;
        }
    },
    actions: {
        _Login: (context, credentials) => {
            context.commit('setLoading', true);

            localStorage.clear();

            axios
                .post(context.state.ROOT_API + '/login', {
                    email: credentials.email,
                    password: credentials.password
                })
                .then(resp => {
                    console.log(resp.data);
                    if (resp.data.status) {

                        // Main Club
                        let club = resp.data.mainClub;
                        localStorage.setItem('_mc', club !== false ? club.container_id : null);

                        // Member ID
                        localStorage.setItem('_mID', parseInt(resp.data.memberId));

                        // Club ID
                        localStorage.setItem('_cID', parseInt(resp.data.clubId));

                        // Is Admin
                        localStorage.setItem('_ia', resp.data.isAdmin);

                        // Access Token
                        localStorage.setItem(context.state.LST, resp.data.access_token);
                        context.commit('setToken', resp.data.access_token);

                        for (let key in localStorage) {
                            console.log(key, localStorage.getItem(key));
                        }

                        router.push({ name: 'home' });
                    } else {
                        context.commit('setFlash', resp.data.message);
                    }
                }, (error) => {
                    context.commit('setFlash', error);
                })
                .catch(function (error) {
                    context.commit('setFlash', error);
                })
                .finally(() => {
                    context.commit('setLoading', false);
                })
        },

        _Logout: (context) => {
            localStorage.clear();
            context.commit('setToken', false);
            for (let key in localStorage) {
                localStorage.removeItem(key);
            }
            //router.push({name: 'login'})
            window.location.reload()
        },

        _addToMenu: ({ commit, state }) => {
            //console.log(state.customMenu);
            let r = router.currentRoute.path;
            state.mainmenu.forEach((item, index) => {
                if (item.to === r) {
                    if (state.customMenu.includes(index)) {
                        state.flashMsg = 'Hai gia questa voce nel tuo menu';
                        return;
                    }
                    let old_menu = state.customMenu.split(',');
                    let new_menu = [index, parseInt(old_menu[0])];
                    localStorage.setItem('_cm', new_menu.join(','));
                    //TODO capire perche non tiene l'ordinamento corretto
                }
            });
        },

        _pushNotify(message) {
            // Controlliamo se il browser supporta le notifiche
            if (!("Notification" in window)) {
                console.log("Questo browser non supporta le Notification API!");
                this.setFlash("Questo browser non supporta le Notification API!");
            }

            // Controlliamo se l'utente accetta le nostre notifiche
            else if (Notification.permission === "granted") {
                navigator.serviceWorker.ready.then((serviceWorker) => {
                    serviceWorker.showNotification(message);
                });
                // Se è tutto a posto, creiamo una notifica
                let notification = new Notification(message);
            }

            // Se l'utente non ha accettato le notifiche, chiediamo il permesso
            else if (Notification.permission !== 'denied') {
                Notification.requestPermission(function (permission) {
                    // Se è tutto a posto, creiamo una notifica
                    if (permission === "granted") {
                        navigator.serviceWorker.ready.then((serviceWorker) => {
                            serviceWorker.showNotification(message);
                        });

                        let notification = new Notification(message);
                    }
                });
            }
        },

    },
    modules: {}
});

export default store;
